import { render, staticRenderFns } from "./GridCategoryPreloader.vue?vue&type=template&id=7740542a&scoped=true&"
var script = {}
import style0 from "./GridCategoryPreloader.vue?vue&type=style&index=0&id=7740542a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7740542a",
  null
  
)

export default component.exports